<template>
  <div class="volume">
    <button @click="handleIconClick" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
      <VolumeFull v-if="volume === 1" :colorMain="mainColor" />
      <VolumeHigh v-else-if="volume >= 0.7" :colorMain="mainColor" :colorSecondary="secondaryColor" />
      <VolumeHalf v-else-if="volume >= 0.35" :colorMain="mainColor" :colorSecondary="secondaryColor" />
      <VolumeLow v-else-if="volume > 0" :colorMain="mainColor" :colorSecondary="secondaryColor" />
      <VolumeOff v-else :colorMain="mainColor" />
    </button>
    <input class="volume__bar"
      v-if="!props.isHideBar"
      type="range"
      min="0"
      max="1"
      step="0.01"
      :value="volume"
      :style="{ '--val': volume }"
      @input="changeVolume(+$event.target.value)"
    />
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { ref, computed } from 'vue';

  //----------------------------------------------------------
  import VolumeFull from './icons/VolumeFull.vue';
  import VolumeHigh from './icons/VolumeHigh.vue';
  import VolumeHalf from './icons/VolumeHalf.vue';
  import VolumeLow from './icons/VolumeLow.vue';
  import VolumeOff from './icons/VolumeOff.vue';

  //----------------------------------------------------------
  const store = useStore();
  const props = defineProps({
    isHideBar: { type: Boolean, default: false },
  });

  //----------------------------------------------------------
  const isHovered = ref(false);

  //----------------------------------------------------------
  //Текущая громкость из store, число от 0 до 1
  const volume = computed(() => store.state.Audioplayer.volume);

  //Основной цвет иконки — меняется на акцентный при наведении на кнопку
  const mainColor = computed(() => isHovered.value ? 'var(--audio-volume-icon-primary-hover)' : 'var(--audio-volume-icon-primary)');

  //Второстепенный цвет иконки (волны, детали) — тоже меняется при наведении
  const secondaryColor = computed(() => isHovered.value ? 'var(--audio-volume-icon-secondary-hover)' : 'var(--audio-volume-icon-secondary-hover)');

  //----------------------------------------------------------
  //Отправляет новое значение громкости в store
  const changeVolume = (val) => {
    store.dispatch('Audioplayer/changeVolume', val);
  };

  //Циклически снижает громкость при каждом клике на иконку:
  const handleIconClick = () => {
    const v = volume.value;
    if (v === 1)        changeVolume(0.7);
    else if (v >= 0.7)  changeVolume(0.5);
    else if (v >= 0.35) changeVolume(0.25);
    else if (v > 0)     changeVolume(0);
    else                changeVolume(1);
  };
</script>

<style scoped lang="scss">
  @import './styles';
</style>